/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button text=""></ion-back-button>
        </ion-buttons>
        <ion-title>{{ $t(`solidaryTransport.geoSearch.${type}`) }}</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container">
        <ion-item>
          <ion-input
            ref="inputSearch"
            type="text"
            name="date"
            v-bind:placeholder="$t('solidaryTransport.geoSearch.placeholder')"
            @input="submitSearch($event)"
          ></ion-input>
          <ion-icon
            size="large"
            color="primary"
            class="rotating"
            v-if="this.$store.state.searchStore.statusGeo == 'loading'"
            name="sync"
          ></ion-icon>
        </ion-item>

        <div v-if="myPosition">
          <ion-item
            class="flex-card"
            v-if="myPosition.displayLabel[0]"
            v-on:click="selectGeo(myPosition)"
          >
            <div class="iconSearch" style="margin-top: 3px;" :style="{ 'background-color': 'black'}">
              <span class="mdi mdi-crosshairs-gps"></span>
            </div>
            <ion-card-header>
              <ion-card-title class="mc-small-card-title" :style="{'color' : darken('#000000') }">{{ myPosition.displayLabel[0] }}</ion-card-title>
              <ion-card-subtitle :style="{'color' : lighten('#000000') }">
                <div>{{ myPosition.displayLabel[1] }}</div>
              </ion-card-subtitle>
            </ion-card-header>
          </ion-item>
        </div>

        <div v-for="group in this.$store.state.searchStore.resultsGeo">
          <p style="margin-bottom: 0px; color: rgba(0,0,0,.6);" v-if="group.points.length > 0">{{$t('search-type.' + group.group)}}</p>
          <div v-for="address in group.points" :key="address.key">
          <ion-item
            class="flex-card"
            v-if="address.displayLabel[0]"
            v-on:click="selectGeo(address)"
          >
            <div class="iconSearch" v-if="address.displayLabel[2]" :style="{ 'background-color': address.displayLabel[2].color }">
              <span class="mdi" :class="address.displayLabel[2].icon"></span>
            </div>
            <ion-card-header>
              <ion-card-title class="mc-small-card-title" :style="address.displayLabel[2] ? {'color' : darken(address.displayLabel[2].color) } :{}">{{ address.displayLabel[0] }}</ion-card-title>
              <ion-card-subtitle :style="address.displayLabel[2] ? {'color' : lighten(address.displayLabel[2].color) } :{}">
                <div>{{ address.displayLabel[1] }}</div>
              </ion-card-subtitle>
            </ion-card-header>
          </ion-item>
        </div>
        </div>

        <p class="mc-carpool-previousSearch" v-if="this.$store.getters.previousSearch.length > 0">Recherches précédentes</p>
        <div v-for="address in this.$store.getters.previousSearch" :key="address.key">
          <ion-item
            class="flex-card"
            v-if="address.displayLabel[0]"
            v-on:click="selectGeo(address)"
          >
            <div class="iconSearch" v-if="address.displayLabel[2]" :style="{ 'background-color': address.displayLabel[2].color }">
              <span class="mdi" :class="address.displayLabel[2].icon"></span>
            </div>
            <ion-card-header>
              <ion-card-title class="mc-small-card-title" :style="address.displayLabel[2] ? {'color' : darken(address.displayLabel[2].color) } :{}">{{ address.displayLabel[0] }}</ion-card-title>
              <ion-card-subtitle :style="address.displayLabel[2] ? {'color' : lighten(address.displayLabel[2].color) } :{}">
                <div>{{ address.displayLabel[1] }}</div>
              </ion-card-subtitle>
            </ion-card-header>
          </ion-item>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">

.mc-carpool-previousSearch {
  margin-bottom: 0px;
}

.flex-card {
  display: flex;
  align-items: center;

  & .iconSearch {
    width: 30px;
    margin-left: 20px;
  }
}

  .mc-small-card-title {
    font-size: 19px;
  }
</style>

<script>
import { toast } from "../../Shared/Mixin/toast.mixin";
import {isPlatform} from "@ionic/core";
import Color from "color";
import {address} from "../../Shared/Mixin/address.mixin";
import { Geolocation } from '@capacitor/geolocation';

export default {
  name: "geo-search",
  mixins: [toast, address],
  components: {},
  created() {
    this.$store.state.searchStore.resultsGeo = [];
    this.unwatch = this.$store.watch(
      (state, getters) => getters.addressessUseToPost,
      (newValue, oldValue) => {
        this.$store.dispatch("treatementUpdateAddresses");
      }
    );
    if(isPlatform(window.document.defaultView, "capacitor")) {
      this.getMyPosition();
    }
  },
  beforeDestroy() {
    this.unwatch();
  },
  data() {
    return {
      type: this.$route.query.type,
      action: this.$route.query.action,
      index: this.$route.query.index,
      myPosition: null
    };
  },

  methods: {
    darken(color) {
      return Color(color).darken(0.3).hex();
    },
    lighten(color) {
      return Color(color).lighten(0.1).hex();
    },
    submitSearch: function(event) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        const searchQuery = event.target.value;
        if (!!searchQuery) {
          this.$store.dispatch("geoSearch", { searchQuery }).catch(err => {
            this.presentToast("Une erreur est survenue", "danger");
          });
        }
      }, 500);
    },

    async getMyPosition() {
      const coordinates = await Geolocation.getCurrentPosition();
      this.$store.dispatch("getAddressesByCoordinate", {latitude: coordinates.coords.latitude.toString(), longitude: coordinates.coords.longitude.toString()}).then(res => {
        if (res.data['hydra:member'].length > 0) {
          this.myPosition = this.addressToPoint(res.data['hydra:member'][0]);
        }
      }).catch(err => {

      });
    },

    selectGeo: function(address) {
      let addressDTO = this.pointToAddress(address);
      this.$store.dispatch('setPreviousSearch', address);
      let displayGeo = this.formatAddress(address);
      switch (this.action) {
        case "solidaryTransport.search": {
          this.$store.commit("solidaryAddressUpdate", addressDTO)

          switch (this.type) {
            case "register": {
              this.$store.commit("solidaryUserAddressUpdate", addressDTO)
              break;
            }

            case "request.home": {
              this.$store.commit("solidaryRequestHomeAddressUpdate", addressDTO)
              break;
            }

            case "request.origin": {
              this.$store.commit("solidaryRequestOriginAddressUpdate", addressDTO)
              break;
            }

            case "request.destination": {
              this.$store.commit("solidaryRequestDestinationAddressUpdate", addressDTO)
              break;
            }

            case "volunteer.home": {
              this.$store.commit("solidaryVolunteerHomeAddressUpdate", addressDTO)
              break;
            }
            case "user.home": {
              this.$store.commit("updateUserAddress", {addressDTO : addressDTO});
              break;
            }
          }
          break;
        }

        default:
          break;
      }
      this.$router.back();
    }
  }
};
</script>
